import { render, staticRenderFns } from "./FlowCopyList.vue?vue&type=template&id=1cb3c0b4"
import script from "./FlowCopyList.vue?vue&type=script&lang=js"
export * from "./FlowCopyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb3c0b4')) {
      api.createRecord('1cb3c0b4', component.options)
    } else {
      api.reload('1cb3c0b4', component.options)
    }
    module.hot.accept("./FlowCopyList.vue?vue&type=template&id=1cb3c0b4", function () {
      api.rerender('1cb3c0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/extension/FlowCopyList.vue"
export default component.exports